module.exports = __webpack_public_path__ + "static/img/3.c028cf2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/eng/3.png
// module id = VNL6
// module chunks = 0